"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultItemIconConfig = exports.defaultItemDescriptionConfig = exports.defaultItemTitleConfig = exports.defaultSectionConfig = void 0;
var General_1 = require("./General");
var defaultSectionConfig = {
    dark: false,
    titleConfig: __assign({}, General_1.defaultTitleMargin)
};
exports.defaultSectionConfig = defaultSectionConfig;
var defaultItemTitleConfig = {
    size: 4,
    margin: {
        desktop: '0 0 20px',
        tablet: '0 0 20px',
        mobile: '0 0 20px'
    }
};
exports.defaultItemTitleConfig = defaultItemTitleConfig;
var defaultItemDescriptionConfig = {
    align: 'center'
};
exports.defaultItemDescriptionConfig = defaultItemDescriptionConfig;
var defaultItemIconConfig = {
    size: 8,
    margin: {
        desktop: '0 0 20px',
        tablet: '0 0 20px',
        mobile: '0 0 20px'
    }
};
exports.defaultItemIconConfig = defaultItemIconConfig;
//# sourceMappingURL=ProcessBox.js.map